import type { Map as ImmutableMap, List } from 'immutable';
import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import { TAX_LINE_ITEMS_REDUCER_KEY, type TaxLineItem, type TaxLineItemsStore } from './taxLineItemsTypes';

type State = Pick<RootState, typeof TAX_LINE_ITEMS_REDUCER_KEY>;
type TaxLineItemsByTaxFormId = ImmutableMap<string | undefined, List<TaxLineItem>>;

export const getTaxLineItemsStore = (state: State): TaxLineItemsStore => state[TAX_LINE_ITEMS_REDUCER_KEY];
export const getResourcesById = (state: State): TaxLineItemsStore['resourcesById'] =>
  getTaxLineItemsStore(state).resourcesById;
export const getLoadPending = (state: State): boolean => getTaxLineItemsStore(state).loadPending;
export const getIsLoading = (state: State): boolean => getTaxLineItemsStore(state).isLoading;
export const getError = (state: State): unknown => getTaxLineItemsStore(state).error;
export const getLastSyncDate = (state: State): string | null | undefined => getTaxLineItemsStore(state).lastSyncDate;

export const getTaxLineItemForId = (state: State, id: string): TaxLineItem | undefined =>
  getResourcesById(state).get(id);

export const getTaxLineItemsByTaxFormId: (state: State) => TaxLineItemsByTaxFormId = createSelector(
  getResourcesById,
  (taxLineItemsById) =>
    taxLineItemsById.toList().groupBy((taxLineItem) => taxLineItem.formId) as unknown as TaxLineItemsByTaxFormId,
);
